import { fetcher } from '#lib/backendFetcher';

/**
 * Fetches the targeting vocabulary: website-profile enums (offerings taxonomy, business models,
 * customer types, service areas, tech) with their filter grade, the BA occupation fields, the
 * director age buckets, the company kinds, the discovery sources, the parameter bounds and the
 * feature switches. Enum rows with `filterable: false` are hints only and never sent as filters.
 * @returns {Promise<{
 *   customerTypes: Array<{value: string, label: string, filterable: boolean}>,
 *   businessModels: Array<{value: string, label: string, filterable: boolean}>,
 *   offerings: Array<{value: string, label: string, vertical: string, filterable: boolean}>,
 *   serviceAreas: Array<{value: string, label: string, filterable: boolean}>,
 *   tech: Array<{value: string, label: string, filterable: boolean}>,
 *   filterGrade: Object<string, 'strict'|'hint'>,
 *   occupations: Array<{value: string, label: string, filterable: boolean}>,
 *   ageBuckets: Array<{value: string, label: string}>,
 *   companyKinds: Array<{value: string, label: string, description: string}>,
 *   discoverySources: Array<{value: string, label: string, filterable: boolean}>,
 *   limits: Object<string, {min?: number, max?: number, maxItems?: number, minLength?: number, maxLength?: number}>,
 *   searchEnabled: boolean,
 *   operatingDefault: boolean
 * }>}
 */
export const fetchTargetingVocabulary = async () => {
	return await fetcher('/api/v1/search/targeting/vocabulary');
};
